import React, {Component} from 'react';
import {Form, Input, Icon, Cascader, Select, Button, Modal, Upload, message} from 'antd';
import {Redirect} from 'react-router';
import {adData} from '../../../utils/area';
import './rechargeApplication.less';
import utils from '../../../utils/common';

const {Option} = Select;

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

// 充值详情
class RechargeApplication extends Component {
  state = {
    rechargeAmt: null, // 余额
    showInfo: false, // 打开线下转账账户信息
    finishRecharge: false, // 完成充值
    rechargeMode: null, // 充值方式 2 线下账户 1 返佣账户
    drawABill: null, // 是否开发票 0 是 1 否
    invoiceType: null, // 发票类型
    previewVisible: false, // 是否显示图片预览的弹层
    previewImage: '', // 预览的图片
    fileList: [], // 图片集合
    isSubmiting: false, // 正在提交
    cacheList: [], // 缓存列表
    cache: {}, // 反选的内容
  };

  async componentWillMount() {
    if (window.common.loginOut(this)) {
      this.getCache();
    } else {
      message.error('登录信息失效，请重新登录');
    }
  }

  // 改变条件
  changeValue = (type, value, obj) => {
    const params = {[type]: value};
    type === 'showDetail' ? params.detail = obj : null;
    type === 'invoiceType' ? params.cache = this.state.cacheList[Number(value) - 1] : null;
    if (type === 'finishRecharge' && value === false && this.state.isSubmiting) {
      message.warn('正在提交充值申请');
      return;
    }
    type === 'finishRecharge' ? this.props.history.goBack() : null;
    this.setState(params);
  }


  // 图片预览
  handlePreview = async file => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };

  // 上传之前校验大小
  beforeUpload = (file, fileList) => {
    const isLt2M = file.size < (500 * 1024);
    let canUpload = true;
    if (!isLt2M) {
      message.error('请上传小于500KB的图片!');
      fileList.pop();
      setTimeout(() => {
        this.props.form.setFieldsValue({picture: undefined});
      }, 0);
      canUpload = false;
    }
    return canUpload;
  }

  // 改变付款截图
  changePic = ({fileList}) => {
    Number(fileList) === 0 ? this.props.form.setFieldsValue({picture: undefined}) : null;
    this.setState({fileList});
  }

  // 上传图片
  uploadPic = (file) => {
    const params = {
      goods_pic: file.thumbUrl,
      pic_name: file.name,
    };
    return window.api('eps.upload', params);
  }

  // 获取缓存
  getCache = () => {
    window.api('last.valid.invoice').then(res => {
      res.invoices.forEach(item => {
        if (item.recipient_address) {
          item.residence = item.recipient_address.split('=');
          item.unitAddress = item.residence.pop();
        } else {
          item.residence = [];
          item.unitAddress = '';
        }
        if (item.company_address) {
          item.postalAddress = item.company_address.split('=');
          item.detailedAddress = item.postalAddress.pop();
        } else {
          item.postalAddress = [];
          item.detailedAddress = '';
        }
      });
      this.setState({cacheList: res.invoices, rechargeAmt: this.props.location.state.recharge});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true}) : null;
      message.error(error.service_error_message);
    });
  }

  // 充值
  recharge = (values, picId) => {
    let params = {
      recharge_amt: values.rechargeAmt, // 充值金额
      recharge_type: values.rechargeMode, // 充值类型
      pic_id: picId.length > 0 ? picId : null, // 图片id
      invoice_type: values.drawABill === '0' ? values.drawABill : values.invoiceType, // 发票类型
      invoice_name: values.invoicesName, // 发票名称
      invoice_tax_no: values.invoicesTaxNumber, // 发票税号
      email_address: values.email, // 邮箱地址
      recipient_address: values.postalAddress ? `${values.postalAddress[0]}=${values.postalAddress[1]}=${values.postalAddress[2]}=${values.detailedAddress}` : null, // 收货地址
      recipient_name: values.Addressee, // 收货人姓名
      recipient_phone: values.phoneNumber, // 收货人手机号
      bank_name: values.bank, // 银行名称
      bank_account_no: values.bankAccount, // 银行账户
      company_address: values.residence ? `${values.residence[0]}=${values.residence[1]}=${values.residence[2]}=${values.unitAddress}` : null, // 公司地址
      company_phone: values.telephoneNumber, // 公司电话号
    };
    params = utils.dealElement(params);
    window.api('recharge', params).then(() => {
      this.setState({isSubmiting: false, finishRecharge: true});
    }).catch((error) => {
      error.service_error_code === 'EPS000000801' ? this.setState({redirect: true, isSubmiting: false}) : this.setState({isSubmiting: false});
      message.error(error.service_error_message);
    });
  }

  // 提交表单
  handleSubmit = async e => {
    e.preventDefault();
    Number(this.state.fileList) === 0 ? await this.props.form.setFieldsValue({picture: undefined}) : null;
    await this.setState({isSubmiting: true});
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const uploadAry = [];
        let picId = '';
        if (this.state.fileList.length > 0) {
          this.state.fileList.forEach(item => {
            uploadAry.push(this.uploadPic(item));
          });
          Promise.all(uploadAry).then(res => {
            res.forEach(item => {
              picId = picId === '' ? `${item.id}` : `${picId},${item.id}`;
            });
            this.recharge(values, picId);
          });
        } else {
          this.recharge(values, picId);
        }
      } else {
        this.setState({isSubmiting: false});
      }
    });
  };

  render() {
    const {getFieldDecorator} = this.props.form;
    const {
      showInfo, finishRecharge, previewVisible, previewImage, fileList, rechargeMode, drawABill, invoiceType, redirect, isSubmiting, cache, rechargeAmt
    } = this.state;
    if (redirect) return (<Redirect to="/login" />);
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text"><span style={{width: '150px'}}>500K以内，JPG或PNG格式</span></div>
      </div>
    );

    return (
      <div id="rechargeApplication">
        <Modal
          visible={showInfo}
          title="转账账户信息"
          footer={false}
          onCancel={this.changeValue.bind(this, 'showInfo', false)}
        >
          <div>
            <p>银行账户:</p>
            <p>银行户名: 合肥联拓富数字科技有限公司</p>
            <p>银行开户行: 建设银行合肥蜀山开发区支行</p>
            <p>银行账号: 34001474508053009244</p>
          </div>
          <div style={{marginTop: '20px'}}>
            <p>支付宝账户:</p>
            <p>支付宝账号: liantuojinrong@51ebill.com</p>
            <p>支付宝户名: 合肥联拓金融信息服务有限公司</p>
          </div>
        </Modal>
        <Modal
          title={false}
          footer={false}
          closable={false}
          visible={finishRecharge}
        >
          <p
            style={{fontSize: '25px', lineHeight: '200px', textAlign: 'center'}}
          >{rechargeMode === '1' ? '充值成功' : '已提交申请'}</p>
          <div style={{
            width: '100%', display: 'flex', justifyContent: 'center', margin: '10px 0 20px'
          }}
          >
            <Button
              style={{width: '140px', height: '40px'}}
              type="primary"
              onClick={this.changeValue.bind(this, 'finishRecharge', false)}
            >确定</Button>
          </div>
        </Modal>
        <Form onSubmit={this.handleSubmit}>
          <h1>充值申请</h1>
          <Form.Item label="充值金额">
            {getFieldDecorator('rechargeAmt', {
              rules: [
                {
                  required: true,
                  message: '请填写充值金额',
                },
                {
                  pattern: /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
                  message: '请输入正确的充值金额'
                }
              ],
            })(<Input placeholder="单位为元，最多两位小数" />)}
          </Form.Item>
          <p>充值金额为实际打款金额</p>
          <p>充值账户余额<span style={{color: '#17d159'}}>￥{rechargeAmt}</span></p>
          <p onClick={this.changeValue.bind(this, 'showInfo', true)} style={{marginBottom: '25px', cursor: 'pointer', color: '#3290FF'}}>查看线下转账账户</p>
          <Form.Item label="充值方式" hasFeedback>
            {getFieldDecorator('rechargeMode', {
              rules: [{required: true, message: '请选择充值方式'}],
            })(<Select placeholder="请选择" onChange={this.changeValue.bind(this, 'rechargeMode')}>
              <Option value="2">线下转账</Option>
              <Option value="1">返佣账户充值</Option>
            </Select>)}
          </Form.Item>
          {
            rechargeMode !== null && Number(rechargeMode) === 2 ? <div>
              <Form.Item label="付款截图" hasFeedback>
                {getFieldDecorator('picture', {
                  rules: [
                    {
                      required: true,
                      message: '请上传付款截图',
                    },
                  ],
                })(<div className="clearfix">
                  <Upload
                    accept="image/png, image/jepg, image/jpg"
                    action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={this.handlePreview}
                    onChange={this.changePic}
                    beforeUpload={this.beforeUpload}
                  >
                    {fileList.length >= 3 ? null : uploadButton}
                  </Upload>
                  <Modal visible={previewVisible} footer={null} onCancel={this.changeValue.bind(this, 'previewVisible', false)}>
                    <img alt="example" style={{width: '100%'}} src={previewImage} />
                  </Modal>
                </div>)}
              </Form.Item>
              <Form.Item label="是否开发票" hasFeedback>
                {getFieldDecorator('drawABill', {
                  rules: [
                    {
                      required: true,
                      message: '请选择是否开具发票',
                    },
                  ],
                })(<Select placeholder="请选择" onChange={this.changeValue.bind(this, 'drawABill')}>
                  <Option value="1">是</Option>
                  <Option value="0">否</Option>
                </Select>)}
              </Form.Item>
              {
                drawABill !== null && Number(drawABill) === 1 ? <div>
                  <Form.Item label="发票类型" hasFeedback>
                    {getFieldDecorator('invoiceType', {
                      rules: [
                        {
                          required: true,
                          message: '请选择发票类型',
                        },
                      ],
                    })(<Select placeholder="请选择" onChange={this.changeValue.bind(this, 'invoiceType')}>
                      <Option value="1">增值税普票-纸质</Option>
                      <Option value="2">增值税普票-电子</Option>
                      <Option value="3">增值税专票</Option>
                    </Select>)}
                  </Form.Item>
                  {
                    invoiceType !== null ? <div>
                      <h3>发票信息</h3>
                      <Form.Item label="名称">
                        {getFieldDecorator('invoicesName', {
                          initialValue: cache ? cache.invoice_name : '',
                          rules: [
                            {
                              required: true,
                              message: '请输入发票名称',
                            },
                            {
                              max: 40,
                              message: '最多输入40个字',
                            }
                          ],
                        })(<Input placeholder="请输入发票名称" />)}
                      </Form.Item>
                      <Form.Item label="税号">
                        {getFieldDecorator('invoicesTaxNumber', {
                          initialValue: cache ? cache.invoice_tax_no : '',
                          rules: [
                            {
                              required: true,
                              message: '请输入发票税号',
                            },
                            {
                              pattern: /^[a-zA-Z\d]+$/,
                              message: '只能输入数字或字母'
                            },
                            {
                              max: 18,
                              message: '最多输入18位',
                            }
                          ],
                        })(<Input placeholder="请输入发票税号" />)}
                      </Form.Item>
                      {
                        Number(invoiceType) === 3 ? <div>
                          <Form.Item label="银行账户">
                            {getFieldDecorator('bankAccount', {
                              initialValue: cache ? cache.bank_account_no : '',
                              rules: [
                                {
                                  required: true,
                                  message: '请输入银行账户',
                                },
                                {
                                  pattern: /^\d+$/,
                                  message: '只能输入数字'
                                },
                                {
                                  max: 25,
                                  message: '最多输入25位数字',
                                }
                              ],
                            })(<Input placeholder="请输入银行账户" />)}
                          </Form.Item>
                          <Form.Item label="开支银行">
                            {getFieldDecorator('bank', {
                              initialValue: cache ? cache.bank_name : '',
                              rules: [
                                {
                                  required: true,
                                  message: '请输入开支银行',
                                },
                                {
                                  max: 40,
                                  message: '最多输入40个字',
                                }
                              ],
                            })(<Input placeholder="请输入开支银行" />)}
                          </Form.Item>
                          <Form.Item
                            label="单位所在地区"
                          >
                            {getFieldDecorator(
                              'residence',
                              {
                                initialValue: cache ? cache.postalAddress : '',
                                rules: [{type: 'array', required: true, message: '请选择单位所在地区'}],
                              }
                            )(<Cascader options={adData} placeholder="请选择单位所在地区" />)
                            }
                          </Form.Item>
                          <Form.Item label="单位详细地址">
                            {getFieldDecorator('unitAddress', {
                              initialValue: cache ? cache.detailedAddress : '',
                              rules: [
                                {
                                  required: true,
                                  message: '请输入单位详细地址',
                                },
                                {
                                  max: 40,
                                  message: '最多输入40个字',
                                }
                              ],
                            })(<Input placeholder="请输入单位详细地址" />)}
                          </Form.Item>
                          <Form.Item label="电话号码">
                            {getFieldDecorator('telephoneNumber', {
                              initialValue: cache ? cache.company_phone : '',
                              rules: [
                                {
                                  required: true,
                                  message: '请输入电话号码',
                                },
                                {
                                  pattern: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/,
                                  message: '请输入正确的电话号码'
                                },
                                {
                                  max: 40,
                                  message: '最多输入40个字',
                                }
                              ],
                            })(<Input placeholder="请输入电话号码" />)}
                          </Form.Item>
                        </div> : null
                      }
                      <h3>发票回寄信息</h3>
                      {
                        Number(invoiceType) === 2 ? <div>
                          <Form.Item label="邮箱">
                            {getFieldDecorator('email', {
                              initialValue: cache ? cache.email_address : '',
                              rules: [
                                {
                                  required: true,
                                  message: '请输入邮箱地址',
                                },
                                {
                                  pattern: /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/,
                                  message: '请输入正确的邮箱地址'
                                }
                              ],
                            })(<Input placeholder="请输入邮箱地址" />)}
                          </Form.Item>
                        </div> : <div>
                          <Form.Item
                            label="发票邮寄地址"
                          >
                            {getFieldDecorator('postalAddress', {
                              initialValue: cache ? cache.residence : '',
                              rules: [{type: 'array', required: true, message: '请选择发票邮寄地址'}],
                            })(<Cascader options={adData} placeholder="请选择发票邮寄地址" />)
                            }
                          </Form.Item>
                          <Form.Item label="详细地址">
                            {getFieldDecorator('detailedAddress', {
                              initialValue: cache ? cache.unitAddress : '',
                              rules: [
                                {
                                  required: true,
                                  message: '请输入发票邮寄的详细地址',
                                },
                                {
                                  max: 40,
                                  message: '最多输入40个字',
                                }
                              ],
                            })(<Input placeholder="请输入发票邮寄的详细地址" />)}
                          </Form.Item>
                          <Form.Item label="收件人">
                            {getFieldDecorator('Addressee', {
                              initialValue: cache ? cache.recipient_name : '',
                              rules: [
                                {
                                  required: true,
                                  message: '请输入发票收件人',
                                },
                                {
                                  max: 10,
                                  message: '最多输入10个字',
                                }
                              ],
                            })(<Input placeholder="请输入发票收件人" />)}
                          </Form.Item>
                          <Form.Item label="手机号">
                            {getFieldDecorator('phoneNumber', {
                              initialValue: cache ? cache.recipient_phone : '',
                              rules: [
                                {
                                  required: true,
                                  message: '请输入收件人手机号码',
                                },
                                {
                                  pattern: /^1[3456789]\d{9}$/,
                                  message: '请输入正确的手机号码'
                                }
                              ],
                            })(<Input placeholder="请输入收件人手机号码" />)}
                          </Form.Item>
                        </div>
                      }
                    </div> : null
                  }
                </div> : null
              }
            </div> : null
          }
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={isSubmiting}>提交</Button>
            <Button style={{marginLeft: '30px'}} onClick={this.changeValue.bind(this, 'finishRecharge', false)}>取消</Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

const RechargeApplicationForm = Form.create({name: 'register'})(RechargeApplication);

export default RechargeApplicationForm;



// WEBPACK FOOTER //
// ./src/containers/frontEnd/rechargeApplication/rechargeApplication.jsx